/* Cloud Store · Header v2 : JS du header (extrait de sections/cs-header.liquid).
   Charge en defer depuis layout/theme.liquid. Aucune valeur Liquid ici : URL de recherche via
   data-cs-search-url / data-cs-suggest-url sur #csSearchOverlay. Globale unique : window.__csHeaderInit. */
(function () {
  if (window.__csHeaderInit) return; window.__csHeaderInit = true;
  var h = document.querySelector('[data-cs-header]'); if (!h) return;

  // ------------------------------------------------------------------
  // Header v2 : le wrapper de section est sticky (CSS). Ici seulement les états :
  //   desktop (>= 1100) : .is-compact après 120 px de scroll (retour < 70 px)
  //   mobile  (<  1100) : .is-hidden en descendant après 200 px, réapparaît dès qu'on remonte
  // Écouteur passif + requestAnimationFrame ; jamais masqué tiroir/recherche ouverts.
  // ------------------------------------------------------------------
  var root = document.documentElement;
  var mqDesk = window.matchMedia('(min-width: 1100px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var COMPACT_ON = 120, COMPACT_OFF = 70, HIDE_AFTER = 200, DELTA = 6;
  var lastY = Math.max(0, window.scrollY || 0), rafId = 0, compact = false, hiddenState = false;
  function setHidden(v) {
    if (v === hiddenState) return;
    hiddenState = v;
    h.classList.toggle('is-hidden', v);
    root.classList.toggle('hv2-hdr-hidden', v);
    if (v) { var oa = h.querySelector('.cs-account-menu[open]'); if (oa) oa.removeAttribute('open'); }
  }
  function onScrollFrame() {
    rafId = 0;
    if (root.classList.contains('cs-drawer-open')) return; // body verrouillé : scrollY vaut 0
    var y = Math.max(0, window.scrollY || root.scrollTop || 0);
    h.classList.toggle('is-scrolled', y > 8);
    if (mqDesk.matches) {
      setHidden(false);
      if (!compact && y > COMPACT_ON) { compact = true; h.classList.add('is-compact'); }
      else if (compact && y < COMPACT_OFF) { compact = false; h.classList.remove('is-compact'); }
    } else {
      if (compact) { compact = false; h.classList.remove('is-compact'); }
      var dy = y - lastY;
      if (y <= HIDE_AFTER) setHidden(false);
      else if (dy > DELTA) setHidden(true);
      else if (dy < -DELTA) setHidden(false);
    }
    if (y <= HIDE_AFTER || Math.abs(y - lastY) > DELTA) lastY = y;
  }
  function onScroll() { if (!rafId) rafId = requestAnimationFrame(onScrollFrame); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  h.addEventListener('focusin', function () { if (hiddenState) setHidden(false); }); // Tab vers un lien du header masqué
  onScrollFrame();

  // <html class="cs-drawer-open"> tant que le tiroir OU la recherche est affiché (masque Mimi + pop-up en CSS)
  function syncOverlayClass() {
    var open = (drawer && !drawer.hasAttribute('hidden')) || (searchOverlay && !searchOverlay.hasAttribute('hidden'));
    root.classList.toggle('cs-drawer-open', !!open);
  }

  // Mobile drawer : open/close + scroll-lock + Escape + backdrop
  var burger = h.querySelector('[data-cs-burger]');
  var drawer = h.querySelector('[data-cs-header-drawer]');
  // The header has backdrop-filter, which creates a containing block for fixed
  // descendants. Move the drawer to <body> so position:fixed covers the viewport.
  if (drawer && drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }
  var savedScrollY = 0;
  var drawerTrigger = null;
  var drawerPanel = drawer ? drawer.querySelector('.cs-md__panel') : null;
  var drawerCloseBtn = drawer ? drawer.querySelector('button[data-cs-header-drawer-close]') : null;
  function lockBody() {
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBody() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    lastY = savedScrollY;
    window.scrollTo(0, savedScrollY);
  }
  function drawerFocusables() {
    if (!drawerPanel) return [];
    return Array.prototype.filter.call(
      drawerPanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.getClientRects().length > 0; }
    );
  }
  function openDrawer(viaPointer) {
    if (!drawer || !drawer.hasAttribute('hidden')) return;
    drawerTrigger = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : burger;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    // Force reflow then animate via class
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    setHidden(false);
    lockBody();
    syncOverlayClass();
    // Ouverture au doigt/souris : focus sur le panneau (pas d'anneau visible sur la croix) ;
    // au clavier : focus sur la croix.
    if (viaPointer && drawerPanel) { drawerPanel.setAttribute('tabindex', '-1'); drawerPanel.focus({ preventScroll: true }); }
    else if (drawerCloseBtn) drawerCloseBtn.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer || drawer.hasAttribute('hidden')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    unlockBody();
    // Focus rendu au déclencheur (le burger)
    var back = (drawerTrigger && document.contains(drawerTrigger) && drawerTrigger.offsetParent !== null) ? drawerTrigger : burger;
    if (back && back.offsetParent !== null) back.focus({ preventScroll: true });
    drawerTrigger = null;
    var done = false;
    var hide = function () { if (done) return; done = true; drawer.setAttribute('hidden', ''); syncOverlayClass(); };
    if (mqReduce.matches) { hide(); return; }
    drawer.addEventListener('transitionend', function (e) {
      if (e.target === drawerPanel && e.propertyName === 'transform') hide();
    });
    setTimeout(hide, 360);
  }
  if (burger && drawer) {
    burger.addEventListener('click', function (e) {
      if (drawer.hasAttribute('hidden')) openDrawer(!!(e && e.detail > 0)); else closeDrawer();
    });
    drawer.querySelectorAll('[data-cs-header-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    // Close drawer when navigating via in-drawer link
    drawer.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () { closeDrawer(); });
    });
    // Piège de focus : Tab / Maj+Tab bouclent dans le panneau
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = drawerFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      var outside = !drawerPanel.contains(a) || a === drawerPanel;
      if (e.shiftKey && (a === first || outside)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || outside)) { e.preventDefault(); first.focus(); }
    });
    // Un seul accordéon ouvert à la fois (repli JS si l'attribut name n'est pas géré)
    var accs = drawer.querySelectorAll('details.cs-md__acc');
    accs.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        accs.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
    // Passage en desktop avec le tiroir ouvert : on le ferme
    var onDeskChange = function (e) { if (e.matches) closeDrawer(); };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onDeskChange); else if (mqDesk.addListener) mqDesk.addListener(onDeskChange);
  }

  // Mega-menu : hover-intent + keyboard + touch + click-outside
  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 280;
  var items = h.querySelectorAll('[data-cs-mega]');
  var openTimers = new WeakMap();
  var closeTimers = new WeakMap();
  var activeItem = null;
  var suppressFocusOpen = false; // Échap : rendre le focus au déclencheur sans rouvrir le panneau

  function isCoarse() { return window.matchMedia('(hover: none), (pointer: coarse)').matches; }

  // Header v3 : les panneaux de méga-menu partagent un même bord gauche (début du bloc d'onglets, ramené
  // dans l'écran si besoin) ; hauteur minimale commune en CSS (cs-header.css). La flèche pointe sous l'onglet.
  // Variables posées sur chaque panneau : --cs-mm-left (décalage depuis son onglet), --cs-mm-arrow.
  var navEl = h.querySelector('.cs-nav');
  var MM_PAD = 16;
  function placePanels() {
    if (!navEl || !items.length || !mqDesk.matches) return;
    var first = null, all = navEl.querySelectorAll('.cs-nav__item');
    for (var i = 0; i < all.length; i++) { if (all[i].offsetWidth > 0) { first = all[i]; break; } }
    if (!first) return;
    var anchor = first.getBoundingClientRect().left;
    var vw = document.documentElement.clientWidth;
    var menus = [], maxW = 0;
    items.forEach(function (item) {
      var m = item.querySelector('.cs-megamenu');
      if (!m) return;
      menus.push([item, m]);
      maxW = Math.max(maxW, m.offsetWidth);
    });
    var left = Math.max(MM_PAD, Math.min(anchor, vw - MM_PAD - maxW));
    menus.forEach(function (p) {
      var ir = p[0].getBoundingClientRect();
      var arrow = Math.max(28, Math.min(ir.left + ir.width / 2 - left, p[1].offsetWidth - 28));
      p[1].style.setProperty('--cs-mm-left', (left - ir.left) + 'px');
      p[1].style.setProperty('--cs-mm-arrow', arrow + 'px');
    });
  }
  var placeRaf = 0;
  function schedulePlace() { if (!placeRaf) placeRaf = requestAnimationFrame(function () { placeRaf = 0; placePanels(); }); }
  window.addEventListener('resize', schedulePlace, { passive: true });
  window.addEventListener('load', schedulePlace);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedulePlace);
  if (mqDesk.addEventListener) mqDesk.addEventListener('change', schedulePlace);
  schedulePlace();
  function openItem(item) {
    clearTimeout(openTimers.get(item)); openTimers.delete(item);
    clearTimeout(closeTimers.get(item)); closeTimers.delete(item);
    if (activeItem && activeItem !== item) closeItem(activeItem, true);
    item.classList.add('is-open');
    var link = item.querySelector('[data-cs-mega-link]');
    if (link) link.setAttribute('aria-expanded', 'true');
    activeItem = item;
    placePanels();
  }
  function closeItem(item) {
    if (!item) return;
    clearTimeout(openTimers.get(item)); openTimers.delete(item);
    clearTimeout(closeTimers.get(item)); closeTimers.delete(item);
    item.classList.remove('is-open');
    var link = item.querySelector('[data-cs-mega-link]');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (item === activeItem) activeItem = null;
  }
  function scheduleOpen(item) {
    clearTimeout(closeTimers.get(item));
    var t = setTimeout(function(){ openItem(item); }, OPEN_DELAY);
    openTimers.set(item, t);
  }
  function scheduleClose(item) {
    clearTimeout(openTimers.get(item));
    var t = setTimeout(function(){ closeItem(item); }, CLOSE_DELAY);
    closeTimers.set(item, t);
  }

  items.forEach(function (item) {
    var link = item.querySelector('[data-cs-mega-link]');

    item.addEventListener('mouseenter', function(){ if (!isCoarse()) scheduleOpen(item); });
    item.addEventListener('mouseleave', function(){ if (!isCoarse()) scheduleClose(item); });

    if (link) {
      // Keyboard : focus opens, focusout closes (delayed, allows tab-through)
      link.addEventListener('focus', function(){ if (!suppressFocusOpen) openItem(item); });
      // Flèche bas : ouvre et entre dans le panneau
      link.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        openItem(item);
        var first = item.querySelector('.cs-megamenu a[href]');
        if (first) first.focus();
      });
      // Touch / coarse pointer : first tap opens, second tap navigates
      link.addEventListener('click', function (e) {
        if (isCoarse() && !item.classList.contains('is-open')) {
          e.preventDefault();
          openItem(item);
        }
      });
    }
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) scheduleClose(item);
    });
  });

  // Click outside : close all
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cs-mega]')) {
      items.forEach(function(it){ closeItem(it); });
    }
  });
  // Escape : close active mega-menu (priority) or mobile drawer
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (activeItem) {
      var trigger = activeItem.querySelector('[data-cs-mega-link]');
      closeItem(activeItem);
      suppressFocusOpen = true;
      if (trigger) trigger.focus({ preventScroll: true });
      suppressFocusOpen = false;
      return;
    }
    if (drawer && !drawer.hasAttribute('hidden')) {
      closeDrawer(); // rend le focus au burger
    }
  });
  // Close active mega-menu on resize (positions become stale; mobile breakpoint may hide it)
  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      if (activeItem) closeItem(activeItem);
    }, 120);
  });

  // ------------------------------------------------------------------
  // Search overlay (slide-down predictive search)
  // ------------------------------------------------------------------
  var searchOverlay = document.getElementById('csSearchOverlay');
  if (searchOverlay) {
    if (searchOverlay.parentNode !== document.body) document.body.appendChild(searchOverlay);

    var searchTrigger = h.querySelector('[data-cs-search-trigger]');
    var searchInput = searchOverlay.querySelector('[data-cs-search-input]');
    var searchForm = searchOverlay.querySelector('[data-cs-search-form]');
    var searchClear = searchOverlay.querySelector('[data-cs-search-clear]');
    var searchEmpty = searchOverlay.querySelector('[data-cs-search-empty]');
    var searchLoading = searchOverlay.querySelector('[data-cs-search-loading]');
    var searchResults = searchOverlay.querySelector('[data-cs-search-results]');
    var searchNoResults = searchOverlay.querySelector('[data-cs-search-noresults]');
    var searchFooter = searchOverlay.querySelector('[data-cs-search-footer]');
    var searchSeeAll = searchOverlay.querySelector('[data-cs-search-see-all]');
    var searchProducts = searchOverlay.querySelector('[data-cs-search-products]');
    var searchCollections = searchOverlay.querySelector('[data-cs-search-collections]');
    var searchArticles = searchOverlay.querySelector('[data-cs-search-articles]');
    var searchQueryEl = searchOverlay.querySelector('[data-cs-search-query]');
    var searchBase = searchOverlay.getAttribute('data-cs-search-url') || '/search';
    var suggestBase = searchOverlay.getAttribute('data-cs-suggest-url') || '/search/suggest';
    var quoteFr = (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0;
    var searchSavedScroll = 0;

    function lockScroll() {
      searchSavedScroll = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + searchSavedScroll + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      lastY = searchSavedScroll;
      window.scrollTo(0, searchSavedScroll);
    }

    // Header v3 / E3 : l'overlay peut s'ouvrir depuis la loupe (< 1600 px) ou depuis le champ visible de la barre ;
    // le focus est rendu a l'element qui l'a ouvert (le champ visible ne rouvre pas l'overlay quand on lui rend le focus).
    var hdrForm = h.querySelector('[data-cs-header-search]');
    var hdrInput = h.querySelector('[data-cs-header-search-input]');
    var searchOpener = null, suppressHdrOpen = false, kbdFocus = false;
    function returnSearchFocus() {
      var t = searchOpener;
      if (!t || t.offsetParent === null) t = (hdrInput && hdrInput.offsetParent !== null) ? hdrInput : searchTrigger;
      if (!t || t.offsetParent === null) return;
      suppressHdrOpen = true;
      try { t.focus({ preventScroll: true }); } finally { suppressHdrOpen = false; }
    }
    function openSearch(opener, prefill) {
      if (!searchOverlay.hasAttribute('hidden')) return;
      searchOpener = (opener && opener.nodeType === 1) ? opener : searchTrigger;
      searchOverlay.removeAttribute('hidden');
      searchOverlay.setAttribute('aria-hidden', 'false');
      void searchOverlay.offsetWidth;
      searchOverlay.classList.add('is-open');
      if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'true');
      setHidden(false);
      lockScroll();
      syncOverlayClass();
      var q0 = (prefill != null) ? String(prefill) : (searchInput ? searchInput.value : '');
      if (searchInput) searchInput.value = q0;
      setTimeout(function () {
        if (!searchInput) return;
        searchInput.focus();
        var n = searchInput.value.length;
        try { searchInput.setSelectionRange(n, n); } catch (e) {}
      }, 50);
      if (q0.trim()) runSearch(q0);
      else { if (searchClear) searchClear.hidden = true; showState('empty'); }
    }
    function closeSearch() {
      if (searchOverlay.hasAttribute('hidden')) return;
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'false');
      if (hdrInput && searchInput) hdrInput.value = searchInput.value;
      unlockScroll();
      var done = false;
      var hide = function () { if (done) return; done = true; searchOverlay.setAttribute('hidden', ''); syncOverlayClass(); };
      if (mqReduce.matches) { hide(); return; }
      searchOverlay.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 360);
    }

    function showState(state) {
      if (searchEmpty) searchEmpty.hidden = (state !== 'empty');
      if (searchLoading) searchLoading.hidden = (state !== 'loading');
      if (searchResults) searchResults.hidden = (state !== 'results');
      if (searchNoResults) searchNoResults.hidden = (state !== 'noresults');
      if (searchFooter) searchFooter.hidden = (state !== 'results');
    }

    if (searchTrigger) {
      searchTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch(searchTrigger);
      });
    }
    searchOverlay.querySelectorAll('[data-cs-search-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeSearch();
        returnSearchFocus();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchOverlay.hasAttribute('hidden')) {
        closeSearch();
        returnSearchFocus();
      }
    });

    // Mimi CTAs
    searchOverlay.querySelectorAll('[data-cs-search-mimi]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeSearch();
        setTimeout(function () {
          var mimi = document.querySelector('[data-cs-mimi-trigger]');
          if (mimi) mimi.click();
        }, 250);
      });
    });

    // Popular search chips
    searchOverlay.querySelectorAll('[data-cs-search-suggest]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var q = chip.getAttribute('data-cs-search-suggest') || '';
        if (!searchInput) return;
        searchInput.value = q;
        searchInput.focus();
        runSearch(q);
      });
    });

    // Clear button
    if (searchClear && searchInput) {
      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        searchClear.hidden = true;
        searchInput.focus();
        showState('empty');
      });
    }

    // Predictive search via Shopify suggest API
    var suggestController = null;
    var suggestTimer = null;

    function escapeHTML(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }
    function formatPrice(value) {
      var n = Number(value);
      if (isNaN(n)) return '';
      try {
        return new Intl.NumberFormat('fr-FR', { style:'currency', currency:'EUR', minimumFractionDigits: 2 }).format(n);
      } catch (e) {
        return n.toFixed(2).replace('.', ',') + ' €';
      }
    }

    // Header v3 / E3 : une colonne sans resultat est masquee (plus de tiret « — »)
    function setCol(target, n) {
      var col = target && target.closest ? target.closest('.cs-search-overlay__col') : null;
      if (col) col.hidden = !n;
    }
    function renderProducts(items) {
      if (!searchProducts) return;
      setCol(searchProducts, items && items.length);
      if (!items || !items.length) { searchProducts.innerHTML = ''; searchProducts.removeAttribute('data-n'); return; }
      searchProducts.setAttribute('data-n', items.length);
      searchProducts.innerHTML = items.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[^.]+)(\?|$)/, '_120x$1$2') : (p.image || '');
        var price = (p.price !== undefined && p.price !== null) ? formatPrice(p.price) : '';
        var compare = (p.compare_at_price && Number(p.compare_at_price) > Number(p.price)) ? formatPrice(p.compare_at_price) : '';
        return ''
          + '<a class="cs-search-product" href="' + escapeHTML(p.url) + '">'
          +   (img ? '<span class="cs-search-product__img"><img src="' + escapeHTML(img) + '" alt="" loading="lazy" decoding="async" width="120" height="120"></span>' : '<span class="cs-search-product__img cs-search-product__img--ph"></span>')
          +   '<span class="cs-search-product__body">'
          +     '<span class="cs-search-product__title">' + escapeHTML(p.title) + '</span>'
          +     '<span class="cs-search-product__meta">'
          +       (price ? '<span class="cs-search-product__price">' + price + '</span>' : '')
          +       (compare ? '<span class="cs-search-product__compare">' + compare + '</span>' : '')
          +     '</span>'
          +   '</span>'
          + '</a>';
      }).join('');
    }
    function renderSimpleList(target, items, kind) {
      if (!target) return;
      setCol(target, items && items.length);
      if (!items || !items.length) { target.innerHTML = ''; return; }
      target.innerHTML = items.map(function (it) {
        return '<a class="cs-search-link cs-search-link--' + kind + '" href="' + escapeHTML(it.url) + '"><span>' + escapeHTML(it.title) + '</span></a>';
      }).join('');
    }

    function runSearch(q) {
      q = (q || '').trim();
      if (searchClear) searchClear.hidden = !q;
      if (searchSeeAll) searchSeeAll.href = searchBase + '?q=' + encodeURIComponent(q) + '&type=product';
      if (!q) { showState('empty'); return; }
      showState('loading');

      if (suggestController && suggestController.abort) suggestController.abort();
      try { suggestController = new AbortController(); } catch (e) { suggestController = null; }

      var url = suggestBase + '.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,article'
        + '&resources[limit]=6&resources[options][unavailable_products]=last';

      var fetchOpts = suggestController ? { signal: suggestController.signal } : {};
      fetch(url, fetchOpts)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          var products = res.products || [];
          var collections = res.collections || [];
          var articles = res.articles || [];
          // Grossiste B2B : jamais dans la recherche publique
          products = products.filter(function (p) { return !(p.url && p.url.indexOf('/products/grossiste-') !== -1); });
          collections = collections.filter(function (c) { return !(c.url && c.url.indexOf('/collections/grossiste') !== -1); });
          var total = products.length + collections.length + articles.length;
          if (searchQueryEl) searchQueryEl.textContent = quoteFr ? '« ' + q + ' »' : '\u201c' + q + '\u201d';
          if (total === 0) { showState('noresults'); return; }
          renderProducts(products.slice(0, 6));
          renderSimpleList(searchCollections, collections.slice(0, 5), 'collection');
          renderSimpleList(searchArticles, articles.slice(0, 4), 'article');
          if (searchResults) {
            var np = products.length > 0, nc = collections.length > 0, na = articles.length > 0, nv = (np ? 1 : 0) + (nc ? 1 : 0) + (na ? 1 : 0);
            searchResults.classList.toggle('is-products-only', np && nv === 1);
            searchResults.classList.toggle('is-one-col', !np && nv === 1);
            searchResults.classList.toggle('is-two-cols', np && nv === 2);
            searchResults.classList.toggle('is-two-even', !np && nv === 2);
            searchResults.classList.toggle('is-three-cols', nv === 3);
          }
          showState('results');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showState('empty');
        });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value;
        if (searchClear) searchClear.hidden = !q;
        clearTimeout(suggestTimer);
        if (!q.trim()) { showState('empty'); return; }
        suggestTimer = setTimeout(function () { runSearch(q); }, 180);
      });
    }
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        var q = searchInput && searchInput.value.trim();
        if (!q) { e.preventDefault(); searchInput && searchInput.focus(); }
      });
    }

    // Champ de recherche visible de la barre (>= 1600 px) : un clic, le focus a la souris ou la saisie ouvrent l'overlay
    // avec la requete ; Entree (champ non vide) envoie le formulaire vers /search?q=... (langue gardee par routes.search_url).
    // Le focus au clavier (Tab) n'ouvre rien : la premiere frappe le fait.
    document.addEventListener('keydown', function (e) { if (e.key === 'Tab') kbdFocus = true; }, true);
    document.addEventListener('pointerdown', function () { kbdFocus = false; }, true);
    if (hdrInput) {
      hdrInput.addEventListener('focus', function () {
        if (suppressHdrOpen || kbdFocus) return;
        openSearch(hdrInput, hdrInput.value);
      });
      hdrInput.addEventListener('click', function () { openSearch(hdrInput, hdrInput.value); });
      hdrInput.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openSearch(hdrInput, hdrInput.value); }
      });
      hdrInput.addEventListener('input', function () {
        if (searchOverlay.hasAttribute('hidden')) { openSearch(hdrInput, hdrInput.value); return; }
        if (searchInput) { searchInput.value = hdrInput.value; searchInput.dispatchEvent(new Event('input')); }
      });
    }
    if (hdrForm) {
      hdrForm.addEventListener('submit', function (e) {
        if (!hdrInput || hdrInput.value.trim()) return;
        e.preventDefault();
        openSearch(hdrInput, '');
      });
    }
  }
})();
